/****************************************************
 * Module Name:  stickerPrintModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import { Box, Button, Container, TextField } from "@mui/material";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import "./../../style/modalstyle.css";
import logo from '../../images/pansuriya.jpg'
import Utility from "../../utility/utility";

const StickerPrintModal = ({
    show,
    stoneIds,
    handleClose
}) => {

    const [data, setData] = useState(stoneIds);

    const stickerPrintMap = new Map();
    stickerPrintMap.set('1', '171');
    stickerPrintMap.set('2', '154');
    stickerPrintMap.set('3', '137');
    stickerPrintMap.set('4', '120');
    stickerPrintMap.set('5', '103');
    stickerPrintMap.set('6', '86');
    stickerPrintMap.set('7', '69');
    stickerPrintMap.set('8', '52');
    stickerPrintMap.set('9', '35');
    stickerPrintMap.set('10', '17');
    stickerPrintMap.set('11', '2');

    const handleClick = () => {

        const strArr = (typeof data === "string") ? data.split(',').map(id => id.trim()) : data.map(id => id.toString());
        let content = '';

        strArr.sort().forEach((id1, index) => {
            const trimmedId = id1.trim();

            if (trimmedId !== "") {
                let distanceFromStart;

                if (trimmedId.length <= 11) {
                    distanceFromStart = stickerPrintMap.get(trimmedId.length.toString());
                } else {
                    distanceFromStart = stickerPrintMap.get('11');
                }

                content += [
                    'O',
                    'Q143, 1',
                    'q399',
                    'S4',
                    'D10',
                    'ZT',
                    'JF',
                    'N',
                    `A${distanceFromStart},20,0,5,1,1,N,"${trimmedId}"`,
                    'P1'
                ].join('\n');

                // Add form feed (\f) except after the last item
                if (index < strArr.length - 1) {
                    content += '\n\\f\n';
                } else {
                    content += '\n';
                }
            }
        });

        // Generate the file for download
        const blob = new Blob([content], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'sticker.txt';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        handleClose()
    }


    return (
        <div>
            <Modal show={show} onHide={handleClose} enforceFocus={false}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <img
                            src={logo}
                            height="40pt"
                            width="40pt"
                            alt={Constants.COMPANY_SITE}
                        />
                        &nbsp;&nbsp;Sticker Printing
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container maxWidth="xxl">
                        <Box
                            sx={{
                                width: "100%",
                                position: "relative",
                                "& .MuiTablePagination-selectLabel": {
                                    marginTop: "15px",
                                },
                                "& .MuiTablePagination-displayedRows": {
                                    marginTop: "15px",
                                },
                                "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                                    fontWeight: Constants.defaultFontWeight,
                                },
                                "& .css-1knaqv7-MuiButtonBase-root-MuiButton-root": {
                                    color: "#1976d2",
                                    padding: "4px 5px",
                                    borderRadius: "4px",
                                },
                                "& .css-cc8tf1": {
                                    fontWeight: Constants.defaultFontWeight,
                                },
                                "& .css-znmrd6-MuiButtonBase-root-MuiButton-root": {
                                    color: "#1976d2",
                                    padding: "5px 5px",
                                    borderRadius: "4px",
                                },
                                height: "20vh",
                            }}
                        >
                            <TextField
                                margin="normal"
                                fullWidth
                                multiline
                                rows={4}
                                label="Enter Stone IDs"
                                placeholder="Enter Stone IDs"
                                value={data}
                                onChange={(e) => setData(Utility.ConvertNewLineToComma((e.target.value).toUpperCase()))}
                            />
                        </Box>

                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button sx={{ mr: 1 }} variant="contained" color="info" onClick={handleClick}>
                        Submit
                    </Button>
                    <Button variant="contained" color="error" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default StickerPrintModal;